import { render, staticRenderFns } from "./AcountAutomaticDetail.vue?vue&type=template&id=33204aea&scoped=true"
import script from "./AcountAutomaticDetail.vue?vue&type=script&lang=js"
export * from "./AcountAutomaticDetail.vue?vue&type=script&lang=js"
import style0 from "./AcountAutomaticDetail.vue?vue&type=style&index=0&id=33204aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33204aea",
  null
  
)

export default component.exports